<template>
    <BaseDialog
        :showDialog="showDeletionDialog"
        maxDialogWidth="500"
        maxCardHeight="500"
        headline="lang_GENERAL_DELETION_DIALOG_TITLE_DELETE_ENTRY"
        :close="closeDialog"
        :alvqa="alvqa"
    >
        <template v-slot:dialogText>
            <v-container fluid>
                <v-row v-if="additionalDialogText !== ''">
                    <v-col v-html="additionalDialogText"></v-col>
                </v-row>
                <v-row>
                    <v-col :alvqa="alvqa + '-text'">
                        {{ $t('lang_GENERAL_DELETION_DIALOG_TEXT') }}<br />
                        {{ $t('lang_GENERAL_DELETION_DIALOG_WRITE_DELETE') }}
                    </v-col>
                </v-row>
            </v-container>
        </template>

        <template v-slot:dialogActions>
            <v-container>
                <v-row>
                    <v-col>
                        <v-text-field 
                            v-model="userInput" 
                            :messages="$t(errorMessage)" 
                            depressed
                            @keydown.enter="checkUserInput()"
                            class="ml-0 mr-0"
                            label='"delete"'
                            :alvqa="alvqa + '-textfield-delete'"
                            autofocus
                        ></v-text-field>
                    </v-col>
                    <v-col class="text-right" align-self="center">
                        <BaseButton 
                            @click="checkUserInput()"
                            label="lang_GENERAL_CONFIRM"
                            :alvqa="alvqa+'-button-confirm'"
                        />
                    </v-col>
                </v-row>
            </v-container>
        </template>
    </BaseDialog>
</template>

<script>
import BaseDialog from '../_base/BaseDialog'
import BaseButton from '../_buttons/BaseButton'

export default {
    name: "DeletionDialog",
    components: {
        BaseDialog,
        BaseButton
    },
    props: {
        context: {
            default: '',
            type: String
        },
        useContextSetinVuex: {
            default: false,
            type: Boolean
        },
        additionalDialogText: {
            default: '',
            type: String
        }
    },
    data() {
        return {
            userInput: '',
            errorMessage: '',
            alvqa: "deletion-dialog",
            defaultContext: this.$store.getters.getDeletionDialogContext
        }
    },
    computed: {
        showDeletionDialog: {
            get() { return this.$store.getters.getShowDeletionDialog },
            set(showDeletionDialog) { this.$store.commit('setShowDeletionDialog', showDeletionDialog) }
        },
        contextSetInVuex: { 
            get() { return this.$store.getters.getDeletionDialogContext },
            set(context) { this.$store.commit('setDeletionDialogContext', context) }
        },
    },
    methods: {        
        deleteSelectedEntries() { 
            let usedContext
            if(this.useContextSetinVuex) usedContext = this.contextSetInVuex 
            else usedContext = this.context

            // Mixpanel tracking
            let action = 'Delete > ' + usedContext
            let entities = this.$store.getters['get'+usedContext]
            let joinedEntities = (Array.isArray(entities) && entities.length) ? entities.join(', ') : '';
            mixpanel.track(action , {
                'entityIds': entities || [],
                'routePath': this.$route.path,
                'userId': this.$store.getters.getUser.id,
            });

            this.$store.dispatch('delete'+ usedContext) 
            this.showDeletionDialog = false
            this.userInput = ''
            this.errorMessage = ''
            if (this.$store._mutations['setIsAll' + usedContext]) {
                this.$store.commit('setIsAll' + usedContext, false)
            }
        },
        closeDialog() {
            this.showDeletionDialog = false

            // Check if context starts with Selected, because these should be set to empty array
            if(this.contextSetInVuex && this.contextSetInVuex.startsWith('Selected') 
                && this.$store._mutations['set' + this.contextSetInVuex]) {

                this.$store.commit('set' + this.contextSetInVuex, [])
            }

            this.userInput = ''
            this.errorMessage = ''
            this.contextSetInVuex = ''
        },
        checkUserInput() { 
            if(this.userInput === 'delete' || this.userInput === 'Delete') this.deleteSelectedEntries()
            else this.errorMessage = 'lang_GENERAL_DELETION_DIALOG_WRITE_DELETE'
        }
    }
}
</script>